import React from "react";

const CreateLeadTestPrepForm = ({
  mode,
  formData,
  setFormData,
  handleChange,
  sectionsRef,
}) => {
  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    setFormData((prevData) => {
      let selectedTests = Array.isArray(prevData.name_test_preparation_required)
        ? [...prevData.name_test_preparation_required]
        : [];

      if (checked) {
        selectedTests.push(value);
      } else {
        selectedTests = selectedTests.filter((test) => test !== value);
      }

      return {
        ...prevData,
        name_test_preparation_required: selectedTests,
      };
    });
  };

  const handleChangeCountry = (e) => {
    const { value, type } = e.target;

    setFormData((prevState) => {
      let selectedCountries = Array.isArray(prevState.country)
        ? [...prevState.country]
        : [];

      if (type === "checkbox") {
        if (selectedCountries.includes(value)) {
          selectedCountries = selectedCountries.filter(
            (country) => country !== value
          );
        } else {
          selectedCountries.push(value);
        }
        return { ...prevState, country: selectedCountries };
      } else {
        return { ...prevState, other_country: value };
      }
    });
  };

  return (
    <div
      className="p-6 border-b-2 border-gray-300 space-y-8"
      ref={sectionsRef.examTestPrep}
      id="examTestPrep"
    >
      <div className="p-2 space-y-2">
        <h2 className="text-lg font-semibold text-purple-700 mb-4">
          Exams, Test Prep, and Visa Details
        </h2>

        {/* Test Preparation */}
        <div className="flex justify-between">
          <label
            htmlFor="name_test_preparation_required"
            className="font-semibold"
          >
            Name of tests you require coaching for * (Multiple select)
          </label>
          <div className="flex flex-col w-1/2">
            {[
              "GRE",
              "GMAT",
              "IELTS/TOEFL/Duolingo/PTE",
              "PSAT/SAT/ACT",
              "Indian University Undergraduate Entrance exams (IPMAT, NPAT, FEAT, AAT, CUET)",
              "LNAT/LSAT",
              "UCAT/BMAT",
              "Indian University MBA Entrance Exam (CAT, CET, XAT, IIFT, SNAP, NPAT)",
              "Indian Universities Law Entrance Exam (CLAT/AILET/MHCET)",
              "NCHMCT-JEE (Hotel management entrance test)",
              "Others",
            ].map((option) => (
              <label className="flex items-center" key={option}>
                <input
                  type="checkbox"
                  value={option}
                  onChange={handleCheckboxChange}
                  checked={
                    formData.name_test_preparation_required &&
                    formData.name_test_preparation_required.includes(option)
                  }
                  disabled={mode === "view"}
                  className="mr-2"
                />
                {option}
              </label>
            ))}
          </div>
        </div>

        {/* Exam Date */}
        <div className="flex justify-between">
          <label htmlFor="exam_date" className="font-semibold">
            When do wish to give the exam *
          </label>
          <select
            name="exam_date"
            value={formData.exam_date}
            onChange={handleChange}
            className="border rounded-lg p-2 mt-1 w-1/2"
            required
            disabled={mode === "view"}
          >
            <option value="">Select one from the options below</option>
            <option value="Within 3 months">Within 3 months</option>
            <option value="After 6 months">After 6 months</option>
            <option value="After a year">After a year</option>
          </select>
        </div>

        {/* Preferred Mode of Teaching */}
        <div className="flex justify-between">
          <label htmlFor="preferred_mode_of_teaching" className="font-semibold">
            Preferred mode of coaching *
          </label>
          <select
            name="preferred_mode_of_teaching"
            value={formData.preferred_mode_of_teaching}
            onChange={handleChange}
            className="border rounded-lg p-2 mt-1 w-1/2"
            required
            disabled={mode === "view"}
          >
            <option value="">Select one from the options below</option>
            <option value="Online">Online</option>
            <option value="Offline">Offline</option>
            <option value="Private">Private</option>
            <option value="Anything works">Anything works</option>
          </select>
        </div>

        {/* Intended Countries */}
        <div className="flex justify-between">
          <label htmlFor="country" className="font-semibold">
            Intended Countries (Multiple select)*
          </label>
          <div className="flex flex-col w-1/2">
            {[
              "USA",
              "UK",
              "Australia",
              "Canada",
              "Germany",
              "India",
              "Ireland",
              "Newzealand",
              "Others",
            ].map((country) => (
              <label key={country} className="flex items-center">
                <input
                  type="checkbox"
                  value={country}
                  onChange={handleChangeCountry}
                  checked={
                    formData.country && formData.country.includes(country)
                  }
                  disabled={mode === "view"}
                  className="mr-2"
                />
                {country}
              </label>
            ))}
          </div>
        </div>

        {/* Other Countries for Abroad Studies */}
        {formData.country && formData.country.includes("Others") && (
          <div className="flex justify-between">
            <label htmlFor="other_country" className="font-semibold">
              Other Countries For Abroad studies (If Applicable)
            </label>
            <input
              type="text"
              name="other_country"
              value={formData.other_country}
              onChange={handleChange}
              className="border rounded-lg p-2 mt-1 w-1/2"
              disabled={mode === "view"}
            />
          </div>
        )}

        {/* Special Requests */}
        <div className="flex justify-between">
          <label htmlFor="special_requests_info" className="font-semibold">
            Mention any other information/preference if any
          </label>
          <textarea
            name="special_requests_info"
            value={formData.special_requests_info}
            onChange={handleChange}
            className="border rounded-lg p-2 mt-1 w-1/2"
            disabled={mode === "view"}
          />
        </div>
      </div>
    </div>
  );
};

export default CreateLeadTestPrepForm;
